/**
 * Prop firms à masquer dans les sélecteurs Tradovate.
 *
 * Certaines prop firms n'utilisent pas Tradovate comme plateforme : les
 * proposer dans le wizard de connexion laisse croire qu'une synchronisation
 * est possible alors qu'elle ne le sera jamais. On filtre côté sélecteur
 * uniquement — les templates restent actifs et visibles partout ailleurs
 * (création de compte manuelle, import CSV, PropFirmManager), puisque ces
 * comptes se gèrent toujours dans Edgely, sans sync broker.
 *
 * Le filtre porte sur le `slug`, stable en base, et non sur le nom affiché
 * qui peut être renommé par un admin.
 */
export const TRADOVATE_EXCLUDED_PROP_FIRM_SLUGS = ["topstep", "bulenox"] as const;

interface TemplateLike {
  slug?: string | null;
}

/**
 * Retire les prop firms hors Tradovate d'une liste de templates.
 *
 * Générique plutôt que typé sur `PropFirmTemplateSnapshot` : les deux
 * sélecteurs concernés consomment la query avec des types différents
 * (snapshot typé d'un côté, `any[]` de l'autre).
 */
export function filterTradovatePropFirms<T extends TemplateLike>(templates: T[]): T[] {
  return templates.filter(
    (tpl) =>
      !TRADOVATE_EXCLUDED_PROP_FIRM_SLUGS.includes(
        (tpl.slug ?? "") as (typeof TRADOVATE_EXCLUDED_PROP_FIRM_SLUGS)[number],
      ),
  );
}
